import ProtectedLayout from "./Protected.presenter";
export default ProtectedLayout;
